'use strict';

function uploadSuccesPage($selector, data) {
    $selector.empty().html(data.succesPageHtml);
};
function liveChatEnable() {
    $('.helpButton, #embeddedMessagingConversationButton').css({
        display: 'block',
        visibility: 'visible'
    });
};
function liveChatDiseble() {
    $('.helpButton, #embeddedMessagingConversationButton').css({
        display: 'none',
        visibility: 'hidden'
    });
}

function inputFieldsValid() {
    var valid = true;
    var $idField = $('#order-id-value');
    var $emailField = $('#order-email-value');
    var regExp = /^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

    if ($emailField.val() === '') {
        $emailField.addClass('cc-error');
        $('#searchorder-form-email-error > .cc-text-message-error').text($emailField.attr('data-missing-error'));
        $emailField[0].focus();
        valid = false;
    } else if (!regExp.test($emailField.val())) {
        $emailField.addClass('cc-error');
        $('#searchorder-form-email-error > .cc-text-message-error').text($emailField.attr('data-pattern-mismatch'));
        $emailField[0].focus();
        valid = false;
    }
    if ($idField.val() === '') {
        $idField.addClass('cc-error');
        $('#searchorder-form-number-error > .cc-text-message-error').text($idField.attr('data-missing-error'));
        $idField[0].focus();
        valid = false;
    }

    return valid;
}

module.exports = {
    openContactUsModal: function() {
        $(document).on('click', '.js-open-contact', function() {
            var url = $(this).data('urlcontact');
            var orderNumber = $(this).data('ordernumber');
            var issueType = $(this).data('issuetype');
            $('body').addClass('cc-blocked');
            $.ajax({
                url: url,
                method: 'POST',
                data: {
                    page: 'ORDER-requestInfo',
                    search: true
                },
                success: function (data) {
                    $('#js-contactUs-product-overlay').html(data);
                    $('#orderNumber').val(orderNumber);
                    $('#problem').val(issueType);
                    $('#genderSelect').selectpicker();
                    $('#genderSelect option').each(function() {
                        if ($(this).prop('selected') === true && !$(this).hasClass('bs-title-option')) {
                            $('#genderSelect').siblings().find('.filter-option-inner-inner').css('color', '#262626');
                        }
                    });
                }
            });
            $('#js-contact-modal').fadeIn();
            liveChatDiseble();
        });
    },
    closeModal: function() {
        $(document).on('click', '.js-close-modal', function() {
            $('body').removeClass('cc-blocked');
            $('#js-contact-modal').fadeOut();
            liveChatEnable();
        });
    },
    closeModalbyOverLay: function() {
        $(document).on('click', '.js-contactUs-closeBy-overlay', function() {
            $('body').removeClass('cc-blocked');
            $('#js-contact-modal').fadeOut();
            liveChatEnable();
        });
    },
    submitContactUsModal: function() {
        $(document).on('click', '#orderContactSubmit', function() {
            var url = $('.js-orderContact-action').data('action');
            var form = $('#infoOrder');
            form.spinner().start();
            $.ajax({
                url: url,
                method: 'POST',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    uploadSuccesPage($('#infoOrder'), data);
                },
                error: function (data) {
                }
            });
        });
    },

    openOrderSectionCollapsibleBox: function() {
        $(document).on('click', '.cc-mobile .cc-order-detail-page .cc-status-detail .cc-order-status', function() {
            if ($(this).hasClass('cc-open-section')) {
                $(this).removeClass('cc-open-section').attr('aria-expanded', 'false');
            } else {
                $(this).addClass('cc-open-section').attr('aria-expanded', 'true');
            }
            $('.js-collapse-order-status').each(function() {
                if ($(this).hasClass('d-none')) {
                    $(this).removeClass('d-none');
                } else {
                    $(this).removeClass('d-none').addClass('d-none');
                }
            });
        });
    },

    searchOrder: function() {
        $(document).on('click', '.js-search-order', function() {
            // clear previous error messages
            $('.cc-feedback-message > .cc-text-message-error').empty();
            $('input.cc-error').removeClass('cc-error');
            var url = $(this).data('url');
            var orderID = $('#order-id-value').val();
            var orderEmail = $('#order-email-value').val();
            $('.js-error-container').empty();
            // check if input fields are valid
            if (! inputFieldsValid()){
                return;
            }
            $.spinner().start();
            $.ajax({
                url: url,
                dataType: 'json',
                data: {
                    trackOrderNumber: orderID,
                    trackOrderEmail: orderEmail
                },
                method: 'GET',
                success: function (data) {
                    if (!data.success) {
                        if (data.errorField === 'email') {
                            $('#order-email-value').addClass('cc-error');
                            $('#searchorder-form-email-error > .cc-text-message-error').text(data.errorMsg);
                            $('#order-email-value')[0].focus();
                        }
                        else if (data.errorField === 'orderId') {
                            $('#order-id-value').addClass('cc-error');
                            $('#searchorder-form-number-error > .cc-text-message-error').text(data.errorMsg);
                            $('#order-id-value')[0].focus();
                        }

                        $.spinner().stop();
                    } else {
                        document.cookie = 'orderID' + "=" + (orderID || "") + "; path=/";
                        document.cookie = 'orderEmail' + "=" + (orderEmail || "") + "; path=/";
                        document.cookie = 'lastPage' + "=" + (document.URL || "") + "; path=/";
                        $('.cc-order-detail-page').replaceWith(data.renderedTemplate);
                        $('.cc-breadcrumbs').replaceWith(data.breadcrumbsTemplate);
                        $('.js-show-order-detail').removeClass('d-none');
                        $('.js-order-search-breadcrumbs').removeClass('d-none');
                        $('.js-searchOrderForm').addClass('d-none');
                        $('.js-breadcrumb-container-order-detail').addClass('d-none');
                        $('.js-main-title-dashboard').text($('.js-main-title-dashboard').data('resulttext'));
                        $('.js-collapse-order-status').removeClass('d-none');
                        // $('#return-open-side-modal').replaceWith(data.returnTemplate);
                        var returnTemplateUrl = data.returnTemplateUrl;
                        $.ajax({
                            url: returnTemplateUrl,
                            method: 'GET',
                            success: function (data) {
                                if (data) {
                                    $('#return-open-side-modal').replaceWith(data);
                                }
                                $.spinner().stop();
                            },
                            error: function () {
                                $.spinner().stop();
                            }
                        });
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });

        $(document).ready(function () {
            // Per ritornare alla order details dalla pagina di reso
            if ($('#direct-to-details').length > 0) {
                var url = $('#direct-to-details').data('url');
                var orderID = $('#direct-to-details').data('orderid');
                var orderEmail = $('#direct-to-details').data('email');
                $.spinner().start();
                $.ajax({
                    url: url,
                    dataType: 'json',
                    data: {
                        trackOrderNumber: orderID,
                        trackOrderEmail: orderEmail
                    },
                    method: 'GET',
                    success: function (data) {
                        if (!data.success) {
                            $('#order-id-value').addClass('cc-error');
                            $('#order-email-value').addClass('cc-error');
                            $('.js-error-container').removeClass('d-none').text(data.errorMsg);
                        } else {
                            $('.cc-order-detail-page').replaceWith(data.renderedTemplate);
                            $('.cc-breadcrumbs').replaceWith(data.breadcrumbsTemplate);
                            $('.js-show-order-detail').removeClass('d-none');
                            $('.js-order-search-breadcrumbs').removeClass('d-none');
                            $('.js-searchOrderForm').addClass('d-none');
                            $('.js-breadcrumb-container-order-detail').addClass('d-none');
                            $('.js-main-title-dashboard').text($('.js-main-title-dashboard').data('resulttext'));
                            $('.js-collapse-order-status').removeClass('d-none');
                            // $('#return-open-side-modal').replaceWith(data.returnTemplate);
                            var returnTemplateUrl = data.returnTemplateUrl;
                            $.ajax({
                                url: returnTemplateUrl,
                                method: 'GET',
                                success: function (data) {
                                    if (data) {
                                        $('#return-open-side-modal').replaceWith(data);
                                    }
                                    $.spinner().stop();
                                },
                                error: function () {
                                    $.spinner().stop();
                                }
                            });
                        }
                        $.spinner().stop();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });

        $(document).on('click', '.js-update-with-template', function () {
            document.cookie = 'orderID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
            document.cookie = 'orderEmail=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
        });
    }
};
